<template>
  <div class="">
    <b-modal
      v-model="profilePopup"
      centered
      hide-footer
      no-close-on-backdrop
      title=""
      size="lg"
      @close="closePopup"
    >
      <b-card>
        <div class="tabs-container">
          <b-tabs id="profile" v-model="activeTab" lazy pills class="tab-action-btn-fill-container" justified>
            <b-tab title="Account" icon-pack="feather" icon="icon-user">
              <template #title size="18">
                <div>
                  <feather-icon icon="UserIcon" size="18" />
                  <span>Account</span>
                </div>
              </template>
              <div class="tab-text">
                <div id="account">
                  <b-row class="mx-2" cols="12">
                    <b-col cols="12" md="6" class="mt-1">
                      <b-form-group :state="!$checkFullName(accountInfo.fullname).state" :invalid-feedback="$checkFullName(accountInfo.fullname).message
                        ">
                        <label for="Full Name">Full Name</label>
                        <b-form-input id="Full Name" v-model="accountInfo.fullname" :class="$checkFullName(accountInfo.fullname).state
                          ? ''
                          : 'danger-select'
                          " :state="$checkFullName(accountInfo.fullname).state" debounce="5000"
                          placeholder="Full Name" />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6" class="mt-1">
                      <b-form-group :state="$checkPhoneNumber(accountInfo.phone_number).state" :invalid-feedback="$checkPhoneNumber(accountInfo.phone_number).message
                        ">
                        <label for="Contact Number">Contact Number</label>
                        <b-form-input id="Contact Number" v-model="accountInfo.phone_number" :class="$checkPhoneNumber(accountInfo.phone_number).state
                          ? ''
                          : 'danger-select'
                          " :state="$checkPhoneNumber(accountInfo.phone_number).state
                            " placeholder="Contact Number" />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6" class="mt-1">
                      <b-form-group :state="accountInfo.email_address.length > 4 &&
                        accountInfo.email_address.includes('@') &&
                        accountInfo.email_address.includes('.')
                        ? true
                        : false
                        " :invalid-feedback="`A valid email address is required`">
                        <label for="Email">Email Address</label>
                        <b-form-input id="Email" v-model="accountInfo.email_address" type="email"
                          placeholder="Email" />
                      </b-form-group>
                    </b-col>
                    <b-col v-for="(answer, index) in accountInfo.answers" :key="index" cols="12" md="6" class="mt-1">
                      <b-form-group :state="accountInfo.answers[index].question.length > 0" :invalid-feedback="`This question must be answered`">
                        <label :for="answer.question"> {{ answer.question }} </label>
                        <b-form-input :id="answer.question" v-model="accountInfo.answers[index].answer" />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div class="d-flex flex-row-reverse my-2">
                    <ButtonSpinner :is-loading="isLoading">
                      <b-button
                        variant="warning"
                        class="mx-1 click-save"
                        @click="saveApplicationUserData"
                      > 
                        Save Data 
                      </b-button>
                    </ButtonSpinner>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="Resume" icon-pack="feather" icon="icon-file-text">
              <template #title size="18">
                <div id="upload-resume">
                  <feather-icon id="resume-tab" icon="FileTextIcon" size="18" />
                  <span>Resume</span>
                </div>
              </template>
              <div class="tab-text">
                <div id="resume">
                  <div class="mx-3 my-2 py-1">
                    <div class="mt-2 d-flex flex-wrap justify-content-center align-items-center">
                      <div class="d-flex flex-gap-md" style="height: 60px !important">
                        <file-pond ref="pond-resume" name="resume-upload" label-idle="Upload a new resume file."
                          accepted-file-types="application/pdf, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          style="height: 60px !important; width: 250px" :server="resumeServer" :files="resumeFiles"
                          credits="false" @init="handleResumePondInit" />
                      </div>

                      <div class="d-flex flex-wrap w-100">
                        <!-- <b-button
                          v-if="accountInfo.resume_file && normal == true"
                          id="#button-with-loading"
                          class="mt-1 shadow-lg"
                          :class="{'w-100': (isMobile || isTablet), 'mr-2': !(isMobile || isTablet)}"
                          variant="warning"
                          @click="$refs.uploadResume.click()"
                        >Update My Resume</b-button> -->

                        <!-- <b-button v-if="
                          false && accountInfo.resume_file && normal == true
                        " id="#button-with-loading" class="shadow-sm px-5" :class="{
                          'w-100': isMobile || isTablet,
                          'mr-2': !(isMobile || isTablet),
                        }" style="width: 250px; height: 66px" variant="primary" @click="viewUploadedResume">View your
                          resume</b-button> -->
                      </div>
                    </div>

                    <div v-if="file_source" class="m-2 w-full" style="height: 100vh !important">
                      <iframe v-if="document_type == 'pdf'" :src="`${file_source}`" width="100%"
                        style="height: 100vh !important" frameborder="0" />

                      <iframe v-else :src="`${file_source}`" width="100%" style="height: 100vh !important"
                        frameborder="0" />
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
    </b-card>
    </b-modal>
  </div>
</template>

<script>
import { listingsMixin } from '@/views/event-management-system/mixins/listingsMixins'
import vueFilePond from 'vue-filepond'
// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import { ValidationProvider, ValidationObserver } from "vee-validate"
import VSelect from "vue-select"

import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import "flatpickr/dist/themes/airbnb.css"
import { v4 as uuid } from 'uuid'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
)

export default {
  components: {
    FilePond,
    VSelect,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  mixins: [listingsMixin],
  props: {
    activatePopup: { type: Boolean, default: false },
    applicationId: { type: String, default: "" },
    jobPosition: { type: String, default: "" },
    hiringManagerId: { type: String, default: "" },
    jobOwnerId: { type: String, default: "" },
  },
  data() {
    return {
      configdateTimePicker: {
        inline: false,
      },
      dobConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      isLoading: false,
      activeTab: 0,
      resumeServer: {},
      resumeFiles: [],
      profilePopup: false,
      accountInfo: {
        fullname: "",
        phone_number: "",
        email_address: "",
        resume_file: "",
        // resume_file_url: ""
        answers: [],
        application_status: ""
      },
      file_source: "",
      document_type: "",
    }
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 1) {
        this.viewUploadedResume()
        this.changeOfTab(2)
      } else if (newVal === 2) {
        this.changeOfTab(3)
      } else if (newVal === 3) {
        this.changeOfTab(6)
      }
    },
    activatePopup(newVal) {
      this.profilePopup = newVal
    },
    applicationId(newVal) {
      this.getCurrentApplicationUserData(newVal)
    }
  },
  mounted() {
    // this.viewUploadedResume()
  },
  methods: {
    async saveApplicationUserData() {
      let proceed = true

      if (!this.$checkFullName(this.accountInfo.fullname).state) {
        this.$toastDanger(
          "Invalid Value",
          this.$checkFullName(this.accountInfo.fullname).message
        )
        proceed = false
      }

      this.accountInfo.phone_number =
        this.accountInfo.phone_number.toString()

      const checkedPhoneNumber = this.$checkPhoneNumber(
        this.accountInfo.phone_number
      )

      if (
        !checkedPhoneNumber.state &&
        this.$route.name === "edit-profile"
      ) {
        this.$toastDanger("Invalid Value", checkedPhoneNumber.message)
        proceed = false
      }

      if (this.accountInfo.email_address.length <= 4 ||
          !this.accountInfo.email_address.includes('@') ||
          !this.accountInfo.email_address.includes('.')) {
        this.$toastDanger("Invalid Email Address", "Your email address must be in a valid format")
        proceed = false
      }

      // Add question validation
      if (this.accountInfo.answers.length > 0) {
        const invalidAnswers = this.accountInfo.answers.filter((answer) => {
          return this.$isEmpty(answer.answer)
        })

        if (invalidAnswers && invalidAnswers.length > 0) {
          this.$toastDanger("Invalid Answers", "You must answer every questions!")
          proceed = false
        }
      }
      

      if (proceed) {
        this.isLoading = true

        this.$bvModal
          .msgBoxConfirm("Do you also want to update your profile with these data?", {
            title: "Update Profile Data",
            size: "sm",
            okVariant: "success",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-success",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              this.saveProfile(false)
            }
          })
        
        if (!this.accountInfo.application_status) {
          // directly update the current application user data to the db
          this.$http.put(`/api/update-application-user-data/${this.applicationId}`, {
            data: this.accountInfo
          }).then((response) => {
            if (response.data.success) {
              this.$toastSuccess("Data Updated Successfully", "Your application user data has been updated successfully")
              this.isLoading = false
            }
          }).catch((error) => {
            this.$toastDanger("An Error Occured", "An error occured while updating your application user data, please try again!")
            this.isLoading = false
          })
        } else {
          // send notif to recruiter
          // create new notification data first to the db then trigger the socket io
          const firstNotifId = uuid()
          const secondNotifId = uuid()

          const newNotificationHiringManager = {
            id: firstNotifId,
            title: `Application's User Data Modified`,
            content: {
              title: `Application's User Data Modified`,
              message: `Applicant ${this.$store.state.auth.ActiveUser.fullname} wants to modify the application user data for your ${this.jobPosition} job`,
              link: "",
            },
            sender_id: this.$store.state.auth.ActiveUser.id,
            receiver_id: this.hiringManagerId,
            type: "application_modification_request_notification",
            meta: {
              related_notif_id: secondNotifId,
              data: this.accountInfo,
              application_id: this.applicationId,
              job_position: this.jobPosition,
              request_sender: this.$store.state.auth.ActiveUser.fullname
            },
            download_link_expired_date: ""
          }

          const newNotificationJobOwner = {
            id: secondNotifId,
            title: `Application's User Data Modified`,
            content: {
              title: `Application's User Data Modified`,
              message: `Applicant ${this.$store.state.auth.ActiveUser.fullname} wants to modify the application user data for your ${this.jobPosition} job`,
              link: "",
            },
            sender_id: this.$store.state.auth.ActiveUser.id,
            receiver_id: this.jobOwnerId,
            type: "application_modification_request_notification",
            meta: {
              related_notif_id: firstNotifId,
              data: this.accountInfo,
              application_id: this.applicationId,
              job_position: this.jobPosition,
              request_sender: this.$store.state.auth.ActiveUser.fullname
            },
            download_link_expired_date: ""
          }

          try {
            await this.$http.post(
              `/api/notifications`,
              newNotificationHiringManager
            )

            await this.$http.post(
              `/api/notifications`,
              newNotificationJobOwner
            )

            this.$socket.client.emit("refresh_notifications")

            this.$toastSuccess("Request Has Been Sent Successfully!", "Recruiter has seen your application, thus your request to modify the application user data has been sent to the recruiter, please wait for the reply!")
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            this.$toastDanger("An Error Occured", `An error occured while saving your application user data, please try again!`)
          }
          
        }
      }
    },
    async saveProfile(company = false, password = false) {
      if (typeof company === "boolean") {
        const { token } = this.$store.state.auth.ActiveUser
        this.$http.defaults.headers.common.Authorization = `Token ${token}`

        const form_data = {
          "fullname": this.accountInfo.fullname,
          "email_address": this.accountInfo.email_address,
          "phone_number": this.accountInfo.phone_number,
          "resume_file": this.accountInfo.resume_file
        }

        const response = await this.$http.put("/api/user", {
          user: form_data,
        })

        if (response.data.errors) {
          if (response.data.errors[0] === "User not found") {
            localStorage.removeItem("userInfo")
            localStorage.removeItem("email")
            localStorage.removeItem("accessToken")

            this.$router.push("/auth/login")
          } else if (
            response.data.errors.includes("Phone number already in use")
          ) {
            this.$toastDanger(
              "Phone Number Error",
              "Phone number already in use"
            )
          }
          this.isLoading = false
        } else if (response.data.password_error) {
          this.$toastDanger("Password Error", response.data.message)
          this.isLoading = false
        } else {
          this.$toastSuccess(
            "Profile Update",
            "Your profile has been updated successfully!"
          )

          this.$store.commit("auth/UPDATE_USER_INFO", response.data)
        }
      }
    },
    getCurrentApplicationUserData(applicationId) {
      console.log(`application id current: ${applicationId}`)
      this.$http.get(`/api/get-application-user-data/${applicationId}`).then((response) => {

        if (response.data.success) {
          this.accountInfo = response.data.data
          // this.viewUploadedResume()
        } else {
          this.$toastDanger('ATS Notification', "Something went wrong when fetching application's user data'")
          this.closePopup()
        }
      }).catch((error) => {
        this.$toastDanger('ATS Notification', "Something went wrong when fetching application's user data'")
        this.closePopup()
      })
    },
    changeOfTab(currentStep) {
        switch (currentStep) {
          case 2:
            this.activeTab = 1
            break

          case 3:
            this.activeTab = 2

            if (
              this.$isEmpty(this.employmentInfo) &&
              this.$isEmpty(this.accountInfo.resume_file)
            ) {
              this.notify_resume_parser = true
            }
            break

          case 6:
            this.activeTab = 3

            if (this.$isEmpty(this.educationInfo)) {
              this.notify_resume_parser = true
            }
            break

          default:
            break
        
      }
    },
    closePopup() {
      this.profilePopup = false
      this.$emit("close-profile-popup")
    },
    handleResumePondInit() {
      const { id } = this.$store.state.auth.ActiveUser
      this.$handleFilePondInit(this, id, "pond-resume", "user-resume")
    },
    viewUploadedResume() {
      // Math.random() is to prevent image being cache and display the previous file, when user upload or changed the resume file
      // const fileUrl = `${this.accountInfo.resume_file_url}?${Math.random(0, 30000000)}`
      const fileUrl = this.$generatePresignedUrl(this.accountInfo.resume_file)
      if (
        this.accountInfo.resume_file &&
        this.accountInfo.resume_file.toLowerCase().endsWith("pdf")
      ) {
        this.document_type = "pdf"
        this.file_source = `https://docs.google.com/gview?url=${encodeURIComponent(
          fileUrl
        )}&embedded=true&random=${new Date().getTime()}`
      } else {
        this.document_type = "docs"
        this.file_source = `https://docs.google.com/gview?url=${encodeURIComponent(
          fileUrl
        )}&embedded=true&random=${new Date().getTime()}`
      }
      // this.view_resume_popup = true
    },
  },
}
</script>

<style>
</style>
